/* Catalog choices bridge into the supplied Shopify product form and cart. */
(() => {
  function connect(root = document) {
    root.querySelectorAll('[data-pack-selector]').forEach(picker => {
      if (picker.dataset.ready) return;
      picker.dataset.ready = 'true';
      const section = document.getElementById(`MainProduct-${picker.dataset.section}`);
      if (!section) return;
      const radios = [...picker.querySelectorAll('input[type=radio]')];
      if (!radios.some(r => r.checked) && radios[0]) radios[0].checked = true;
      const update = () => {
        const selected = radios.find(r => r.checked);
        if (!selected) return;
        const id = picker.dataset.section;
        const form = document.getElementById(`product-form-${id}`);
        const variant = form?.querySelector('input[name=id]');
        if (variant) { variant.value = selected.value; variant.disabled = false; }
        const price = document.getElementById(`price-${id}`);
        price?.querySelectorAll('.main-price').forEach(node => node.textContent = selected.dataset.money);
        // Each choice is a real catalog price; no invented compare-at price.
        price?.querySelector('.price')?.classList.remove('price--on-sale', 'price--sold-out');
        [`main-atc-price-${id}`,`sticky-atc-price-${id}`].forEach(key => {
          const el = document.getElementById(key);
          if (el) el.textContent = `${selected.dataset.money} · `;
        });
        const stickyPrice = document.getElementById(`sticky-atc-separate-price-${id}`);
        stickyPrice?.querySelectorAll('.price-item--regular,.price-item--sale').forEach(n => n.textContent = selected.dataset.money);
        const available = selected.dataset.available === 'true';
        section.querySelectorAll('.main-product-atc').forEach(btn => {
          btn.disabled = !available;
          if (available) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled','true');
        });
        radios.forEach(r => r.closest('label').classList.toggle('is-selected', r.checked));
        section.querySelectorAll('form.installment input[name=id]').forEach(el => el.value = selected.value);
      };
      picker.addEventListener('change', update);
      update();
    });
    const sticky = document.querySelector('sticky-atc');
    const footer = document.querySelector('.ovylo-footer');
    if (sticky && footer && !sticky.dataset.footerObserved) {
      sticky.dataset.footerObserved = 'true';
      new IntersectionObserver(entries => {
        sticky.classList.toggle('ovylo-footer-visible', entries[0].isIntersecting);
      }).observe(footer);
    }
  }
  document.addEventListener('DOMContentLoaded', () => connect());
  document.addEventListener('shopify:section:load', () => connect());
})();
